import { render } from "./ClockIndicator.vue?vue&type=template&id=7a8f3eff"
import script from "./ClockIndicator.vue?vue&type=script&lang=js"
export * from "./ClockIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__